import { useEffect } from 'react';
import { logger } from '../utils/logger';
import { NETWORK_RETRY } from '../constants/gameplay';

export const useErrorHandlingInit = (setPwaRegistration) => {
  useEffect(() => {
    let errorReportingInstance = null;
    
    // Lazy load errorHandling, networkRetry, and errorReporting to avoid initialization order issues
    Promise.all([
      import('../utils/errorHandling.jsx'),
      import('../utils/networkRetry'),
      import('../utils/errorReporting')
    ]).then(([errorHandlingModule, networkRetryModule, errorReportingMod]) => {
      // Setup global error handling
      errorHandlingModule.setupGlobalErrorHandling();
      
      // Set up network retry defaults
      networkRetryModule.networkRetry.config.maxRetries = NETWORK_RETRY.MAX_RETRIES;
      networkRetryModule.networkRetry.config.baseDelay = NETWORK_RETRY.BASE_DELAY;
      
      // Configure error reporting for production
      if (process.env.NODE_ENV === 'production') {
        errorReportingMod.errorReporting.enable();
      }
      
      errorReportingInstance = errorReportingMod.errorReporting;
    }).catch(err => {
      logger.warn('Failed to load error handling modules:', err);
    });
    
    // Get PWA registration from global
    if (window.emmyPWA?.registration && setPwaRegistration) {
      setPwaRegistration(window.emmyPWA.registration);
    }
    
    // Check URL parameters for notification actions
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('from') === 'notification') {
      logger.info('App opened from notification');
      // Track notification engagement
      if (window.gtag) {
        window.gtag('event', 'app_opened_from_notification', {
          event_category: 'PWA'
        });
      }
    }
    
    return () => {
      if (errorReportingInstance) {
        errorReportingInstance.disable();
      }
    };
  }, [setPwaRegistration]);
};

export default useErrorHandlingInit;
